/* opening act. — fashion / furniture: one Shopify cart, two areas.

   1. Drawer view. <cart-drawer data-oa-home> = the area of the site you are
      on (furniture layout = body.oa-mb), data-oa-view = "home" | "other"
      (the tabs), data-oa-show = the area actually on screen. CSS in
      component-cart-drawer.css hides every [data-oa-group] of the other
      area. The third tab (FURNITURE / FASHION) only shows while the other
      area holds something.

   2. Separate checkouts. A checkout button checks out ONE area: the pieces
      of the other area are parked in localStorage and taken out of the
      cart, then the normal Shopify checkout opens. Back on the site (after
      buying or after leaving the checkout) the parked pieces are put back.
      Which line is furniture comes from /?section_id=oa-cart-groups
      (tag "Furniture", same rule as everywhere else). */
(function () {
  var PARK_KEY = 'oa-cart-parked';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function homeArea() {
    return document.body.classList.contains('oa-mb') ? 'furniture' : 'fashion';
  }
  function otherOf(a) {
    return a === 'furniture' ? 'fashion' : 'furniture';
  }
  function drawer() {
    return document.querySelector('cart-drawer');
  }

  /* ---------------- 1. drawer view ---------------- */
  function apply() {
    var cd = drawer();
    if (!cd) return;
    var home = homeArea();
    if (cd.getAttribute('data-oa-home') !== home) cd.setAttribute('data-oa-home', home);
    var tab = cd.querySelector('[data-oa-cd-tab="other"]');
    var fa = tab ? parseInt(tab.getAttribute('data-oa-fa-count'), 10) || 0 : 0;
    var mb = tab ? parseInt(tab.getAttribute('data-oa-mb-count'), 10) || 0 : 0;
    var count = { fashion: fa, furniture: mb };
    var other = otherOf(home);
    var hasOther = count[other] > 0;
    if (!hasOther && cd.getAttribute('data-oa-view') === 'other') cd.setAttribute('data-oa-view', 'home');
    var show = cd.getAttribute('data-oa-view') === 'other' ? other : home;
    if (cd.getAttribute('data-oa-show') !== show) cd.setAttribute('data-oa-show', show);
    cd.classList.toggle('oa-show-empty', fa + mb > 0 && count[show] === 0);
    if (tab) tab.hidden = !hasOther;
    // CART² / FURNITURE¹ — superscript counts of each tab's area
    var setCount = function (key, n) {
      var el = cd.querySelector('[data-oa-cd-count="' + key + '"]');
      if (!el) return;
      if (el.textContent !== String(n)) el.textContent = n;
      el.hidden = !(n > 0);
    };
    setCount('home', count[home]);
    setCount('other', count[other]);
    var sep = cd.querySelector('.oa-cd-tabs__sep--other');
    if (sep) sep.hidden = !hasOther;
    if (window.oaRvApplyDrawer) {
      window.oaRvApplyDrawer();
    } else {
      // No recently-viewed script on this page: set the tab state here.
      var cartTab = cd.getAttribute('data-oa-view') === 'other' ? 'other' : 'cart';
      cd.querySelectorAll('[data-oa-cd-tab="cart"], [data-oa-cd-tab="other"]').forEach(function (t) {
        var act = !cd.classList.contains('oa-wl-on') && t.getAttribute('data-oa-cd-tab') === cartTab;
        t.classList.toggle('is-active', act);
        t.setAttribute('aria-selected', act ? 'true' : 'false');
      });
    }
  }

  // Tabs YOUR CART / FURNITURE|FASHION - handled here so they work on every
  // page, with or without the recently-viewed script.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-oa-cd-tab="cart"], [data-oa-cd-tab="other"]');
    if (!t) return;
    var cd = t.closest('cart-drawer');
    if (!cd) return;
    cd.classList.remove('oa-rv-on', 'oa-wl-on');
    cd.setAttribute('data-oa-view', t.getAttribute('data-oa-cd-tab') === 'other' ? 'other' : 'home');
    apply();
  });

  window.oaCartSplit = { apply: apply, checkout: checkout, refresh: function () { refreshCartUI(); } };

  function watchDrawer() {
    var cd = drawer();
    if (!cd || cd.__oaSplit) return;
    cd.__oaSplit = true;
    // The drawer replaces its own HTML after every cart change.
    new MutationObserver(function () { apply(); }).observe(cd, { childList: true, subtree: true });
    // Opening from the header always starts on YOUR CART.
    if (window.customElements) {
      customElements.whenDefined('cart-drawer').then(function () {
        var C = customElements.get('cart-drawer');
        if (!C || C.prototype.__oaSplitOpen) return;
        var orig = C.prototype.open;
        C.prototype.open = function () {
          if (!this.classList.contains('active')) this.setAttribute('data-oa-view', 'home');
          apply();
          return orig.apply(this, arguments);
        };
        C.prototype.__oaSplitOpen = true;
      });
    }
    apply();
  }

  /* ---------------- 2. separate checkouts ---------------- */
  // Stored as { at: <ms when parked>, items: [...] }.
  function readParkedRaw() {
    try {
      var v = JSON.parse(localStorage.getItem(PARK_KEY) || 'null');
      if (Array.isArray(v)) return { at: 0, items: v };
      return v && Array.isArray(v.items) ? v : { at: 0, items: [] };
    } catch (e) { return { at: 0, items: [] }; }
  }
  function readParked() {
    return readParkedRaw().items;
  }
  function writeParked(list) {
    try {
      if (list.length) localStorage.setItem(PARK_KEY, JSON.stringify({ at: Date.now(), items: list }));
      else localStorage.removeItem(PARK_KEY);
      return true;
    } catch (e) { return false; }
  }

  function getGroups() {
    return fetch(root + '?section_id=oa-cart-groups', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var s = doc.querySelector('[data-oa-cart-groups]');
        return s ? JSON.parse(s.textContent) : { fashion: [], furniture: [] };
      });
  }
  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  // Check out only `area`. Resolves false when nothing had to be parked (the
  // caller then just lets the normal checkout happen).
  function checkout(area) {
    return Promise.all([getGroups(), getCart()]).then(function (res) {
      var groups = res[0], cart = res[1];
      var otherKeys = groups[otherOf(area)] || [];
      if (!otherKeys.length) return false;
      var park = [], updates = {};
      cart.items.forEach(function (it) {
        if (otherKeys.indexOf(it.key) === -1) return;
        var entry = { id: it.variant_id || it.id, quantity: it.quantity };
        if (it.properties && Object.keys(it.properties).length) entry.properties = it.properties;
        if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) {
          entry.selling_plan = it.selling_plan_allocation.selling_plan.id;
        }
        park.push(entry);
        updates[it.key] = 0;
      });
      if (!park.length) return false;
      // Never take pieces out of the cart unless they are safely stored.
      if (!writeParked(readParked().concat(park))) {
        throw new Error('storage unavailable');
      }
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      }).then(function (r) {
        if (!r.ok) throw new Error('cart update failed');
        return true;
      });
    });
  }

  function areaOfButton(btn) {
    var a = btn.getAttribute('data-oa-checkout-area');
    if (a) return a;
    var cd = btn.closest('cart-drawer');
    if (cd) return cd.getAttribute('data-oa-show') || homeArea();
    return homeArea();
  }

  // The checkout click itself is left alone (the terms app validates it and
  // only lets a valid checkout submit). We step in at the very end, at the
  // form's submit: park the other area, then submit the same form natively.
  window.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    var btn = e.submitter;
    if (!btn || !btn.hasAttribute('data-oa-checkout')) return;
    var form = e.target;
    if (form.__oaGo) return;
    e.preventDefault();
    var area = areaOfButton(btn);
    btn.classList.add('loading');
    var go = function () {
      if (form.__oaGo) return;
      form.__oaGo = true;
      // Open the checkout of the (now one-area) cart directly - the form's
      // updates[] would no longer match the cart once lines were taken out.
      // Quantities and the note are already saved (the cart saves them as
      // they change).
      window.location.assign(root + 'checkout');
      // Still here after a few seconds (navigation didn't happen)? Undo.
      setTimeout(function () {
        if (leaving) return;
        form.__oaGo = false;
        btn.classList.remove('loading');
        restore(true);
      }, 6000);
    };
    // Safety net: whatever happens (network hangs, an error), the normal
    // checkout goes ahead after at most 5 seconds.
    setTimeout(go, 5000);
    checkout(area).catch(function () { return false; }).then(go);
  });

  var leaving = false;
  window.addEventListener('pagehide', function () { leaving = true; });
  window.addEventListener('beforeunload', function () { leaving = true; });
  window.addEventListener('pageshow', function () { leaving = false; });

  // Back on the site: put parked pieces back (skipping what is in the cart
  // already or has sold meanwhile), then refresh what shows the cart.
  // Only on a real return from the checkout (or when forced): another tab
  // that loads while the checkout is still open must NOT put the pieces back,
  // or they would land in that checkout again. After 30 min it's safe anyway.
  var restoring = false;
  function cameFromCheckout() {
    try { return /\/checkouts?\//.test(new URL(document.referrer).pathname); } catch (e) { return false; }
  }
  function restore(force) {
    var raw = readParkedRaw();
    var parked = raw.items;
    if (!parked.length || restoring) return;
    var stale = Date.now() - (raw.at || 0) > 30 * 60 * 1000;
    if (!force && !stale && !cameFromCheckout()) return;
    restoring = true;
    // Claim the list first, so two tabs never put the same pieces back twice.
    writeParked([]);
    getCart()
      .then(function (cart) {
        var inCart = {};
        cart.items.forEach(function (it) { inCart[it.variant_id || it.id] = true; });
        var add = parked.filter(function (p) { return !inCart[p.id]; });
        if (!add.length) return null;
        // One by one, so a sold piece doesn't block the others.
        return add.reduce(function (chain, item) {
          return chain.then(function () {
            return fetch(root + 'cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [item] }),
            }).catch(function () {});
          });
        }, Promise.resolve()).then(function () { return true; });
      })
      .then(function (changed) {
        restoring = false;
        if (changed) refreshCartUI();
      })
      .catch(function () {
        restoring = false;
        writeParked(readParked().concat(parked)); // try again next time
      });
  }

  function refreshCartUI() {
    if (document.body.classList.contains('template-cart') || /\/cart\/?$/.test(location.pathname)) {
      location.reload();
      return;
    }
    fetch(root + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (secs) {
        var cd = drawer();
        var parse = function (html, sel) {
          var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
          return el ? el.innerHTML : null;
        };
        if (cd && secs['cart-drawer']) {
          var inner = parse(secs['cart-drawer'], '#CartDrawer');
          var target = document.getElementById('CartDrawer');
          // Keep the terms checkbox the legal app filled in (.rale-shortcode):
          // the app only fills it on its own cart requests, an empty one would
          // block the checkout without a box to tick.
          var rale = target && target.querySelector('.rale-shortcode');
          if (inner != null && target) target.innerHTML = inner;
          var fresh = target && target.querySelector('.rale-shortcode');
          if (rale && fresh && rale.childNodes.length) fresh.parentNode.replaceChild(rale, fresh);
          var src = new DOMParser().parseFromString(secs['cart-drawer'], 'text/html').querySelector('cart-drawer');
          if (src) cd.classList.toggle('is-empty', src.classList.contains('is-empty'));
          var ov = document.getElementById('CartDrawer-Overlay');
          if (ov) ov.addEventListener('click', function () { cd.close(); });
        }
        var bub = document.getElementById('cart-icon-bubble');
        if (bub && secs['cart-icon-bubble']) {
          var b = parse(secs['cart-icon-bubble'], '.shopify-section');
          if (b != null) bub.innerHTML = b;
        }
        apply();
      })
      .catch(function () {});
    // Furniture header counters (CART n) - same mini section as oa-mb.js uses.
    if (document.querySelector('[data-oa-mb-cart-count], [data-oa-mb-cart-mini]')) {
      fetch(root + '?section_id=oa-mb-cart-count', { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var m = /data-oa-mb-count="(\d+)"/.exec(html), cnt = m ? +m[1] : 0;
          document.querySelectorAll('[data-oa-mb-cart-count], [data-oa-mb-cart-mini]').forEach(function (n) {
            n.textContent = cnt > 0 ? cnt : '';
          });
        })
        .catch(function () {});
    }
  }

  // Remove: the line fades out at once (the cart request takes ~1s); the
  // re-render afterwards takes it out for good, or brings it back on error.
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('cart-remove-button, [data-oa-mb-cart-remove]');
    if (!rm) return;
    var line = rm.closest('.cart-item, .oa-mb-cart__item');
    if (line) line.classList.add('oa-removing');
  });

  function init() {
    watchDrawer();
    restore();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Coming back with the browser's back button (bfcache) is a return too.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) restore(true);
  });
})();
